module.exports = __webpack_public_path__ + "media/images/new/icons/repay-0706ad3eba3563279ee9978a7be2b26e.png";